var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13C5.23858 13 3 10.7614 3 8C3 5.23858 5.23858 3 8 3C9.63485 3 11.0879 3.78484 12.0006 5H10C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7H14C14.5523 7 15 6.55228 15 6V2C15 1.44772 14.5523 1 14 1C13.4477 1 13 1.44772 13 2V3.10126C11.73 1.805 9.95952 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C10.5922 15 12.8541 13.5904 14.0629 11.5007C14.3395 11.0227 14.1761 10.4109 13.698 10.1344C13.22 9.85785 12.6082 10.0212 12.3317 10.4993C11.4657 11.9964 9.84945 13 8 13Z",
    fill: "currentColor"
  })));
}

export default SvgSync;